import * as Yup from "yup"
import {
	ContractType,
} from "models"
import { DateTime } from "luxon"

export class MatchProposalDetailsFormModel {
	brand: string | null = null
	company: string | null = null
	category: string | null = null
	representative: string | null = null
	sentDate: DateTime | null = null
	expireDate: DateTime | null = null
	contractType: ContractType | null = null
	price: string | null = null
	paymentTerms: string | null = null
	notes: string | null = null
	priority: string | null = null
	status: string | null = null
	compatibility: number | null = null 
}

const MatchProposalDetailsFormValidation = {}

export default Yup.object()
	.shape(
		MatchProposalDetailsFormValidation,
	)
	.required()
